/**
 * For use in the tab header - lets the user know that they should check
 * the form within this tab for errors (sometimes an inline error may have been scrolled off screen)
 */
angular.module('qkr').directive('tabError', (utils) => {
    const linkFn = function(scope, element, attrs, ngModel) {
        // Set default display text
        scope.displayText = '*';

        // Monitor errorObject for changes
        scope.$watch('errorObject', () => {
            if (!utils.isEmpty(scope.errorObject)) {
                if (!utils.hasNoValue(scope.errorKeys)) {
                    let hasError = false;
                    const fieldList = scope.errorKeys.split(',');
                    for (let i = 0; i < fieldList.length; i++) {
                        if (scope.errorObject.hasOwnProperty(fieldList[i])) {
                            hasError = true;
                        }
                    }
                    scope.displayError = hasError;
                } else {
                    scope.displayError = false;
                }
            } else {
                scope.displayError = false;
            }
        });
    };
    return {
        link: linkFn,
        restrict: 'E',
        require: 'ngModel',
        scope: {
            errorObject: '=ngModel',
            errorText: '@',
            errorKeys: '@'
        },
        template: ' <i ng-hide="prod.requiresAvailabilityInfo!==true" class="fa fa-exclamation-triangle" style="color:red;" ng-show="displayError"></i>'
    };
});



// WEBPACK FOOTER //
// ./src/directives/tabError.js